import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function Profile() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ first_name: '', last_name: '', email: '' });
  const [addresses, setAddresses] = useState([]);
  const [editAddr, setEditAddr] = useState(null);
  const [addrForm, setAddrForm] = useState({ street: '', city: '', state: '', pincode: '', phone: '' });

  useEffect(() => {
    if (user) setForm({ first_name: user.first_name || '', last_name: user.last_name || '', email: user.email || '' });
    api.get('auth/addresses/').then(res => setAddresses(res.data.results || res.data)).catch(() => {});
  }, [user]);

  const updateProfile = async (e) => {
    e.preventDefault();
    try {
      const res = await api.patch('auth/profile/', form);
      setUser(res.data);
      toast.success('Profile updated');
    } catch { toast.error('Update failed'); }
  };

  const saveAddress = async (e) => {
    e.preventDefault();
    try {
      if (editAddr?.id) {
        const res = await api.put(`auth/addresses/${editAddr.id}/`, addrForm);
        setAddresses(prev => prev.map(a => a.id === editAddr.id ? res.data : a));
      } else {
        const res = await api.post('auth/addresses/', addrForm);
        setAddresses(prev => [...prev, res.data]);
      }
      setEditAddr(null);
      setAddrForm({ street: '', city: '', state: '', pincode: '', phone: '' });
      toast.success('Address saved');
    } catch { toast.error('Failed to save address'); }
  };

  const deleteAddress = async (id) => {
    try {
      await api.delete(`auth/addresses/${id}/`);
      setAddresses(prev => prev.filter(a => a.id !== id));
      toast.success('Address deleted');
    } catch { toast.error('Failed to delete'); }
  };

  const input = { width: '100%', padding: '10px', border: '1px solid #ddd', marginBottom: 10 };
  const btn = { padding: '6px 14px', border: 'none', cursor: 'pointer', fontSize: 13 };

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: '40px 20px' }}>
      <h2 style={{ fontSize: 22, fontWeight: 300, letterSpacing: 1, marginBottom: 32 }}>My Profile</h2>

      <form onSubmit={updateProfile} style={{ marginBottom: 40 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
          <input placeholder="First Name" value={form.first_name} onChange={e => setForm({ ...form, first_name: e.target.value })} style={{ padding: '10px', border: '1px solid #ddd' }} />
          <input placeholder="Last Name" value={form.last_name} onChange={e => setForm({ ...form, last_name: e.target.value })} style={{ padding: '10px', border: '1px solid #ddd' }} />
        </div>
        <input type="email" placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} style={input} />
        <button type="submit" style={{ ...btn, background: '#1a1a1a', color: '#fff' }}>Save Changes</button>
      </form>

      <h3 style={{ fontWeight: 400, marginBottom: 16 }}>Addresses</h3>
      {addresses.map(a => (
        <div key={a.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', border: '1px solid #eee', marginBottom: 8 }}>
          <span>{a.street}, {a.city}, {a.state} - {a.pincode} | {a.phone}</span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => { setEditAddr(a); setAddrForm({ street: a.street, city: a.city, state: a.state, pincode: a.pincode, phone: a.phone }); }} style={{ ...btn, background: '#eee' }}>Edit</button>
            <button onClick={() => deleteAddress(a.id)} style={{ ...btn, background: '#fee', color: '#c00' }}>Delete</button>
          </div>
        </div>
      ))}

      {editAddr !== null ? (
        <form onSubmit={saveAddress} style={{ padding: 16, border: '1px solid #eee', marginTop: 12 }}>
          <input placeholder="Street" value={addrForm.street} onChange={e => setAddrForm({ ...addrForm, street: e.target.value })} style={input} required />
          <input placeholder="City" value={addrForm.city} onChange={e => setAddrForm({ ...addrForm, city: e.target.value })} style={input} required />
          <input placeholder="State" value={addrForm.state} onChange={e => setAddrForm({ ...addrForm, state: e.target.value })} style={input} required />
          <input placeholder="Pincode" value={addrForm.pincode} onChange={e => setAddrForm({ ...addrForm, pincode: e.target.value })} style={input} required />
          <input placeholder="Phone" value={addrForm.phone} onChange={e => setAddrForm({ ...addrForm, phone: e.target.value })} style={input} required />
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="submit" style={{ ...btn, background: '#1a1a1a', color: '#fff' }}>Save</button>
            <button type="button" onClick={() => setEditAddr(null)} style={{ ...btn, background: '#eee' }}>Cancel</button>
          </div>
        </form>
      ) : (
        <button onClick={() => { setEditAddr({}); setAddrForm({ street: '', city: '', state: '', pincode: '', phone: '' }); }}
          style={{ marginTop: 12, padding: '8px 16px', border: '1px dashed #ccc', background: 'none', cursor: 'pointer' }}>+ Add Address</button>
      )}
    </div>
  );
}
